module.exports = __webpack_public_path__ + "img/30078414_1274410412703843_8290935809419247616_n.0b84200f.jpg";